
import { Injectable } from '@angular/core';
import { NeptuneApi } from '../genericApi/neptune.api';
import { MultiBaseAbstractApi } from '@api/genericApi/multi-base-abstract.api';
import { Observable } from 'rxjs';
import { DigestSubscriberApi } from '@api/briefings/model/digest-subscriber-api';
import { HttpVerbsEnum } from '@api/shared/enums/http-verbs.enum';

@Injectable()
export class DigestSubscriberApiService extends MultiBaseAbstractApi<DigestSubscriberApi, DigestSubscriberApi> {
    constructor(
        private neptuneApi: NeptuneApi
    ) {
        super();
    }

    getList(): Observable<DigestSubscriberApi[]> {
        return this.neptuneApi.api<DigestSubscriberApi[]>(
            '/briefings/digestsubscribers',
            undefined,
            HttpVerbsEnum.GET
        );
    }

    create(resource: DigestSubscriberApi): Observable<number> {
        return this.neptuneApi.api<number>(
            '/briefings/digestsubscribers',
            resource,
            HttpVerbsEnum.POST
        );
    }

    getById(digestSubscriberId: number): Observable<DigestSubscriberApi> {
        return this.neptuneApi.api<DigestSubscriberApi>(
            `/briefings/digestsubscribers/${digestSubscriberId}`,
            undefined,
            HttpVerbsEnum.GET
        );
    }

    update(resource: DigestSubscriberApi): Observable<number> {
        return this.neptuneApi.api<number>(
            `/briefings/digestsubscribers/${resource.id}`,
            resource,
            HttpVerbsEnum.PUT
        );
    }

    deleteById(digestSubscriberId: number): Observable<null> {
        return this.neptuneApi.api<null>(
            `/briefings/digestsubscribers/${digestSubscriberId}`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }

    unsubscribeById(digestId: number, subscriberId: number): Observable<null> {
        return this.neptuneApi.api<null>(
            `/briefings/digestsubscribers/${subscriberId}/digest/${digestId}/unsubscribe`,
            undefined,
            HttpVerbsEnum.DELETE
        );
    }
}
